module.exports = __webpack_public_path__ + "b3f52be70fc1132d7214751b9b379105.svg";